import { render, staticRenderFns } from "./CheatingConfirmModal.vue?vue&type=template&id=5c1cc3d9&scoped=true"
import script from "./CheatingConfirmModal.vue?vue&type=script&lang=js"
export * from "./CheatingConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1cc3d9",
  null
  
)

export default component.exports